import { mintProxyUrl } from "../utils/constants";
import { AxiosBackendHelper } from "../utils/AxiosHelper";

const axiosInstance = AxiosBackendHelper.newInstance();

export class ConfigAPI {
  static async getOrgCustomAttributes() {
    const result = await axiosInstance({
      url: `${mintProxyUrl}/api/Users/org/attributes`,
      method: "GET",
    });
    return result?.data || {};
  }

  static async getTenantConfig() {
    const result = await axiosInstance({
      url: `${mintProxyUrl}/api/registry/tenant-configuration`,
      method: "GET",
    });
    return result?.data || {};
  }
}
